import React from "react";

import {BrandSearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import * as styles from "./NoMoreItems.module.css";

export const NoMoreItems = () => {
    return (
        <div className={styles.noMoreItems}>
            <BrandSearchIcon size="6" wrapperSize="6" wrapperColor="var(--colors-primary)" wrapperType="circle" className={styles.noMoreItemsIcon} />

            <Text align="center" variant="headline_5" mb={1}>
                Nie znaleziono elementów spełniających wybrane kryteria
            </Text>

            <Text align="center" variant="body_copy_2">
                Zmień parametry/filtry aby uzyskać więcej wyników
            </Text>
        </div>
    );
};
import React from "react";

import {BrandSearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import * as styles from "./NoMoreItems.module.css";

export const NoMoreItems = () => {
    return (
        <div className={styles.noMoreItems}>
            <BrandSearchIcon size="6" wrapperSize="6" wrapperColor="var(--colors-primary)" wrapperType="circle" className={styles.noMoreItemsIcon} />

            <Text align="center" variant="headline_5" mb={1}>
                Nie znaleziono elementów spełniających wybrane kryteria
            </Text>

            <Text align="center" variant="body_copy_2">
                Zmień parametry/filtry aby uzyskać więcej wyników
            </Text>
        </div>
    );
};
